import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Tabs, TabPanel } from '@tencent/spaui';
// import ArticleList from "../component/articleList"
import ArticleDetail from '../component/articleDetail';
import ArticleDetailBrand from '../component/articleDetailBrand';
import SidebarMenu from '../component/leftNav';
import { Route, withRouter } from 'react-router-dom';
import ArticleList from './articleList';
const ParamsLength = 3; // 非搜索进入导航时参数至少为3个
@withRouter
class List extends PureComponent {
  render() {
    const {
      tabValue = [],
      sidebarData = [],
      sidebarValue = [],
      match: { params = {} },
    } = this.props;
    const fromSearch = params[0].split('/').length < ParamsLength;
    return (
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', flex: '1 1', paddingTop: 80 }}>
        {!fromSearch ? <SidebarMenu value={sidebarValue} Data={sidebarData} tabValue={tabValue} onChange={this.props.handleSidebarChange} /> : null}
        <Route path={'/list/detailBrand/*'} component={ArticleDetailBrand}></Route>
        <Route path={'/list/detail/*'} component={ArticleDetail}></Route>
        <Route path={'/list/article/*'} exact component={ArticleList}></Route>
      </div>
    );
  }
}
export default connect()(List);
